/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 202309d9 (Tue Mar 17 17:42:15 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface PublicInternationalCommunityLocation
 */
export interface PublicInternationalCommunityLocation {
  /**
   *
   * @type string
   * @memberof PublicInternationalCommunityLocation
   */
  city: string
  /**
   *
   * @type string
   * @memberof PublicInternationalCommunityLocation
   */
  state?: string
  /**
   *
   * @type string
   * @memberof PublicInternationalCommunityLocation
   */
  countryCode?: string
  /**
   *
   * @type string
   * @memberof PublicInternationalCommunityLocation
   */
  postalCode?: string
}

export function PublicInternationalCommunityLocationFromJSON(
  json: any
): PublicInternationalCommunityLocation {
  return PublicInternationalCommunityLocationFromJSONTyped(json, false)
}

export function PublicInternationalCommunityLocationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicInternationalCommunityLocation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    city: json['city'],
    state: !exists(json, 'state') ? undefined : json['state'],
    countryCode: !exists(json, 'countryCode') ? undefined : json['countryCode'],
    postalCode: !exists(json, 'postalCode') ? undefined : json['postalCode'],
  }
}

export function PublicInternationalCommunityLocationToJSON(
  value?: PublicInternationalCommunityLocation | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    city: value.city,
    state: value.state,
    countryCode: value.countryCode,
    postalCode: value.postalCode,
  }
}
